import React, { useState } from 'react';
import {
  StyledPara,
  StyledPanel,
  StyledCollapse,
  StyledContentWrapper,
  TableHeaderWrapper,
} from './styled';
import RenderMetadataGroup from './renderMetadataGroup';
import Tile from './Tile';

const ContentMetadata = ({ streamUrl, contentMetadata }) => {
  const [label, setLabel] = useState('Show URL');
  const onPanelClick = (key) => {
    // When the panel is expanded, the length of key is 1, set to the active panel, else it's an empty object array
    setLabel(key.length ? 'Hide URL' : 'Show URL');
  };

  return (
    <StyledContentWrapper>
      <TableHeaderWrapper>Content Metadata</TableHeaderWrapper>
      <StyledCollapse bordered={false} onChange={onPanelClick}>
        <StyledPanel
          showArrow={false}
          header={<Tile name="Stream URL" value={label} showDivider={false} />}
          key="1"
        >
          <StyledPara>{streamUrl}</StyledPara>
        </StyledPanel>
      </StyledCollapse>
      <RenderMetadataGroup metadataGroup={contentMetadata} />
    </StyledContentWrapper>
  );
};

export default ContentMetadata;
